import { render, staticRenderFns } from "./DeliveryEditDialog.vue?vue&type=template&id=26ff79f6"
import script from "./DeliveryEditDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports